import { useMutation } from '@tanstack/react-query'
import { secureTokenStore } from '@store'
import { api } from '@api'

interface Account {
  id: string
  email: string
  createdAt: string
  updatedAt: string
  isOnboardingCompleted: boolean
}

interface SignInResponse {
  account: Account
  accessToken: string
  refreshToken: string
}

interface SignInCredentials {
  email: string
  password: string
}

const signIn = async (credentials: SignInCredentials): Promise<SignInResponse> => {
  const { data } = await api.post<SignInResponse>('/authentication/sign-in', credentials)

  if (data.accessToken && data.refreshToken) {
    await secureTokenStore.setTokens(data.accessToken, data.refreshToken)
  }

  return data
}

export const useSignIn = () => {
  return useMutation<SignInResponse, Error, SignInCredentials>({
    mutationFn: signIn,
  })
}
